import { NumericInput } from "../numericInput/numericInput";
import React, { useState } from "react";
import { uniqueId } from "lodash-es";
const useUniqueId = (prefix) => {
    const [persistedId] = useState(uniqueId(prefix));
    return persistedId;
};
export const NumericColoredRangeValueControl = ({ value, onChange, colorClassName, renderTooltip, disabled, isGrey = false, }) => {
    const id = useUniqueId("numeric-colored-control-");
    return (React.createElement("div", { className: `range ${isGrey ? "color-unrateable" : colorClassName}` },
        React.createElement(NumericInput, { id: id, className: `range-value ${isGrey ? "color-unrateable" : colorClassName}`, value: value, onChange: onChange, placeholder: disabled ? "" : "Enter", disabled: disabled })));
};
